import type { Option } from 'modules/core/components/Popover/Content'
import i18n from 'modules/core/lib/i18n'

import { Folder } from 'modules/documents/hooks/useGetFolders'

import { ALL_TYPES, SPACES } from './constants'

export const folderOptions = (onRename: () => void, onDelete: () => void) => {
  const options: Option[] = [
    {
      title: i18n.t('settings.folders.item.options.rename.button'),
      onClick: onRename,
    },
    {
      title: i18n.t('settings.folders.item.options.delete.button'),
      onClick: onDelete,
      type: 'wrong',
    },
  ]

  return options
}

export function sortFoldersByName(folders: Folder[]) {
  return [...folders].sort((folder1: Folder, folder2: Folder) => {
    const title1 = getTitle(folder1.name).toLocaleLowerCase()
    const title2 = getTitle(folder2.name).toLocaleLowerCase()
    return title1.localeCompare(title2)
  })
}

export function isWritableEmployeeFolder(folder: Folder, employeeCanSeeDocuments: boolean) {
  return !folder.showOnly && (employeeCanSeeDocuments || !!folder.managePermission)
}

export function isWritableFolder(
  folder: Folder,
  canSeeDocuments = false,
  canSeeAnyEmployeeDocumentsByFolder = false
) {
  return (
    !folder.showOnly &&
    (canSeeDocuments ||
      canSeeAnyEmployeeDocumentsByFolder ||
      !!folder.managePermission ||
      !!folder._policies?.editEmployeeFolderForOthers.can)
  )
}

export function isEmployee(folder: Folder) {
  return folder.space === SPACES.EMPLOYEE_MY_DOCUMENTS
}

export function isPublicCompany(folder: Folder) {
  return folder.space === SPACES.COMPANY_PUBLIC
}

export function isInternalCompany(folder: Folder) {
  return folder.space === SPACES.COMPANY_INTERNAL
}

export function getIcon(folderName: string) {
  switch (folderName) {
    case ALL_TYPES.payslip:
      return 'document-folder-drawer-2'

    case ALL_TYPES.id_document:
      return 'id'

    default:
      return 'folder'
  }
}

export function getTitle(name: string): string {
  switch (name) {
    case ALL_TYPES.adherence:
      return i18n.t('documents.types.adherence')

    case ALL_TYPES.payslip:
    case ALL_TYPES.es_payslip:
    case ALL_TYPES.fr_payslip:
      return i18n.t('documents.types.payslip')

    case ALL_TYPES.payslip_summary:
    case ALL_TYPES.es_payslip_summary:
    case ALL_TYPES.fr_payslip_summary:
      return i18n.t('documents.types.payslip_summary')

    case ALL_TYPES.es_payroll_export:
    case ALL_TYPES.fr_payroll_export:
      return i18n.t('documents.types.payroll_export')

    case ALL_TYPES.contract:
      return i18n.t('documents.types.contract')

    case ALL_TYPES.hiring:
      return i18n.t('documents.types.hiring')

    case 'id-document':
      return i18n.t('documents.types.id-document')

    case ALL_TYPES.novation:
      return i18n.t('documents.types.novation')

    case ALL_TYPES.sick_leave:
      return i18n.t('documents.types.sick-leave')

    case ALL_TYPES.tax:
      return i18n.t('documents.types.tax')

    case ALL_TYPES.social_insurance:
      return i18n.t('documents.types.social_insurance')

    case ALL_TYPES.expenses_company:
      return i18n.t('documents.types.expenses')

    case ALL_TYPES.expenses_employee:
      return i18n.t('documents.types.expenses')
    case ALL_TYPES.training_certificates:
      return i18n.t('documents.types.training_certificates')
    case ALL_TYPES.onboarding:
      return i18n.t('documents.types.onboarding')
    default:
      return name
  }
}
